<template>
  <div class="height-set-for-component">
    <component :is="selectedModalComponent" :pluginInfo="pluginInfo" v-if="isModalVisible" @close="closeModal" style="width:100%;height:100%"></component>
    <plugins-top-nav
    v-if="selectedComponent != 'show-installed-plugins'"
    @changeSelectedPluginComponent='changeSelectedPluginComponent' v-bind="currentProperties" @openAddPlugins="openAddPlugins"></plugins-top-nav>
    <component
      :is="selectedComponent"
      v-bind="currentProperties"
      @close="closeModal"
      @changeSelectedPluginComponent="changeSelectedPluginComponent"
      style="width:100%;" 
      :style="selectedComponent == 'show-installed-plugins'?{'height':'100%'}:{'height':'calc(100% - 60px)'}"
    ></component>
  </div>
</template>

<script>
import pluginsTopNav from "./pluginsTopNav.vue";
import installedPlugins from "./pluginsTable.vue"
import ExternalPluginLoader from "./pluginConfig.vue";

export default {
  components:{
    "plugins-top-nav": pluginsTopNav,
    "show-installed-plugins":installedPlugins,
    "plugin-config":ExternalPluginLoader
  },
  data(){
    return{
      selectedComponent:"show-installed-plugins",
      selectedPluginInfo:{}
    }
  },
  methods:{
    closeModal(){
      this.selectedComponent = "show-installed-plugins";
      this.selectedPluginInfo = {}
    },
    changeSelectedPluginComponent(comp,pluginInfo){
      this.selectedComponent = comp;
      this.selectedPluginInfo = pluginInfo;
    }
  },
  computed: {
    currentProperties() {
      //Dynamically send props
      return {pluginInfo:this.selectedPluginInfo,componentname:this.selectedComponent}
    },
  },
}
</script>

<style lang="scss" scoped>
  .height-set-for-component{
        // height:93%;
        height:calc(100% - 46px);
  }
</style>
